<template>
  <div
    v-if="loading"
    class="app"
    :style="{
      '--bg-color': getThemeVar('--bg-color'),
      '--bg-color2': getThemeVar('--bg-color2'),
      '--menu-text-color': getThemeVar('--menu-text-color'),
      '--border-color': getThemeVar('--border-color'),
      '--hover-bg-color': getThemeVar('--hover-bg-color'),
      '--label-color': getThemeVar('--label-color'),
      '--switcher-bold-color': getThemeVar('--switcher-bold-color'),
      '--chat-hover': getThemeVar('--chat-hover'),
      '--list-color': getThemeVar('--list-color'),
      '--bg-color3': getThemeVar('--bg-color3'),
      '--hover-newbg-color': getThemeVar('--hover-newbg-color'),
      '--pdf-modal-color': getThemeVar('--pdf-modal-color'),
      '--pdf-file-color': getThemeVar('--pdf-file-color'),
    }"
  >
    <vue-progress-bar></vue-progress-bar>

    <div class="app__wrapper">
      <nav-aside></nav-aside>
      <div class="app__block">
        <notifications />

        <transition name="fade">
          <router-view></router-view>
        </transition>
      </div>
    </div>

    <talkdesk />

    <info-btn />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import navAside from '@/components/controls/navAside'
import notifications from '@/components/controls/notifications'

import socket from '@/mixins/socket'
import isLogged from '@/helpers/api/isLogged'
import $vars from '@/helpers/config/vars'
import talkdesk from '@/components/controls/talkdesk'
import infoBtn from '@/components/controls/infoBtn'

export default {
    components: {
        navAside,
        notifications,
        talkdesk,
        infoBtn,
    },
    mixins: [socket],
    data() {
        return {
            loading: true,
            role: window.globalConfig.role,
        }
    },
    computed: {
        ...mapGetters({
            adminData: 'adminDataGetters',
            isDark: 'isDark',
        }),
        auth() {
            return this.$store.state.login.auth
        },
        error() {
            const errors = []

            if (this.$store.state.errors.error.id === 'service_unremovable') {
                errors.push(this.$store.state.errors.error.message)
                return errors
            }
            if (
                this.$store.state.errors.error.data
        && this.$store.state.errors.error.data.fields
            ) {
                this.$store.state.errors.error.data.fields.forEach((element) => {
                    switch (element.name) {
                    case 'phone':
                        errors.push(this.$t('serverError.phone'))
                        break

                    case 'email':
                        errors.push(this.$t('serverError.email'))
                        break

                    case 'password':
                        errors.push(this.$t('serverError.password'))
                        break

                    default:
                        errors.push(this.$t('serverError.error'))
                        break
                    }
                })
            } else if (
                this.$store.state.errors.error.data
        && this.$store.state.errors.error.data.id === 'service_unremovable'
            ) {
                errors.push(this.$t('serverError.service'))
            } else {
                errors.push(this.$t('serverError.error'))
            }
            return errors
        },
        showError() {
            return this.$store.state.errors.show
        },
        isAdminRole() {
            if (window.$role === 'client') {
                return true
            }

            if (this.adminData !== undefined) {
                return this.adminData.role !== null
            }

            return true
        },
    // isDark() {
    //   return this.activeTheme === "dark";
    // }
    },
    methods: {
        ...mapActions({
            getAdminData: 'getAdminData',
            getNotification: 'getNotification',
            getServices: 'getServices',
            fetchOffices: 'offices/fetch',
        }),
        closeError() {
            this.$store.commit('clearError')
        },
        getThemeVar(key) {
            const activeTheme = this.isDark ? 'dark' : 'light'

            return $vars[activeTheme][key]
        },
    },
    async created() {
        this.loading = false

        // await this.$store.dispatch("getAdminData");
        // await this.$store.dispatch("getNotification");
        // await this.$store.dispatch("getServices");
        await this.getAdminData()
        await this.getNotification()
        await this.getServices()
        await this.fetchOffices()

        if (!isLogged()) {
            this.$store.commit('setIsLoading', false)
        } else {
            this.$store.commit('setIsLogged', true)
        }

        this.loading = true
    },
    mounted() {
        if (!this.isDark) {
            document.body.classList.add('light-theme')
            document.body.classList.remove('dark-theme')
        }
    },
}
</script>

<style lang="scss">
@import "src/assets/sass/main";

.app {
  width: 100%;
  height: 100vh;

  &__header {
    width: 100%;
    height: 64px;
    position: relative;
    z-index: 6;
  }

  &__wrapper {
    display: flex;
    align-items: stretch;
    height: 100%;
    width: 100%;
  }

  &__aside {
    position: relative;
    width: 220px;
    flex-shrink: 0;
    height: 100%;
    z-index: 10;
  }

  &__block {
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
    background: var(--bg-color);
    transition: all 0.2s ease-in;
  }
}
</style>
<style lang="scss">
.tooltip {
  display: block !important;
  z-index: 10000;

  .tooltip-inner {
    background: rgba(113, 189, 74, 0.8);
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.popover {
    $color: #f9f9f9;

    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }

    .popover-arrow {
      border-color: $color;
    }
  }

  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}
</style>

<style>
.el-time-spinner__item {
  height: 30px !important;
}
</style>
